import axios from "axios";
import Router from "vue-router";
const onestoreutils = require("onestore-utils");
const logger = require("@/utils/logger");
const config = require("config");
const auth = require("./auth");
const BASE_URL = config.restAPIURL; //'http://localhost:3000';

var router = new Router({
  //mode: "history"
});

export function axiosErrorHandler(err) {
  logger.log('axios http error caught...')
  logger.log(JSON.stringify(err))
  if (err && err.response && err.response.status == 403) {
    logger.log('Deleting session')
    auth.deleteSession();
    logger.log('Redirecting to /')
    router.push('/');
  } else {
    console.error(err);
    alert('Oops something\'s not right :|')
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js